<template>
  <div>
    <div class="container">

      <Panel title="Commande d'administration" collapsible>
        <div class="columns">

          <div class="column">
            <div class="group">
              <label for="cmd">Commande</label>
              <select id="cmd" v-model="builder.commandIndex">
                <option v-for="(e, index) of library" :value="index" :disabled="builder.running">
                  {{ e.short_description }}
                </option>
              </select>
            </div>
            <template v-for="argument of argumentsOfSelected" v-if="selectionReady">
              <div class="group" v-if="argument.key">
                <label for="args">{{ $t(`admin_commands.${argument.key}`) }}</label>
                <select id="args" v-model="builder.parameters[argument.key]">
                  <option :value="s.oldId || s.id" v-for="s of lazySelection[argument.key]" :disabled="builder.running">
                    {{ s.name }}
                  </option>
                </select>
              </div>
            </template>
            <div v-if="selectionReady">
              <label class="m-b-5">Chaîne d'actions</label>
              <template v-for="(check, index) of checkboxes">
                <div class="group">
                  <input :id="`chk_${index}`" type="checkbox" :value="index" v-model="builder.checkedLinks">
                  <label :for="`chk_${index}`">{{ check }}</label>
                </div>
              </template>
            </div>
          </div>

          <div class="column">
            <div class="group" v-if="descriptions" style="margin-top: 20px">
              <label>Description</label>
              <ul v-for="line of descriptions">
                <li>{{ line }}</li>
              </ul>
            </div>
          </div>

        </div>

        <div class="footer-actions" style="margin-top: 20px">
          <button class="btn btn-primary" @click="run" v-if="builder.running === false">Run</button>
          <button class="btn btn-primary" @click="cancel" v-if="builder.running === true">Cancel</button>
        </div>
      </Panel>

      <Panel title="Logs" v-if="logs">
        <ul v-for="line of logs" class="logs">
          <li>{{ line.time }} - {{ line.txt }}</li>
        </ul>
      </Panel>

    </div>
  </div>
</template>

<script>
  import { Core } from '@/core/Core';
  import moment from "moment-timezone";

  export default {
    name: "AdminCommands",

    data() {
      return {
        library: [
          {
            short_description: 'Importer une branche de la V2',
            chain: [
              {
                checkboxLabel: "Configuration et inventaire",
                description: [
                  "Importe les configurations et l'inventaire de chacune des compagnies de cette branche."
                ],
                command: 'ishop:import:company',
                arguments: [
                  { parameter: '--branch', key: 'branch_v2' }
                ]
              }, {
                checkboxLabel: "Programme de fidélité",
                description: [
                  "Importe le programme de fidélité et ses 'levels' de la branche",
                  "Importe les sondages et leurs entrées"
                ],
                command: 'ishop:import:loyalty',
                arguments: [
                  { parameter: '--branch', key: 'branch_v2' }
                ]
              }, {
                checkboxLabel: "Utilisateurs Admin",
                description: [
                  "Importe les utilisateurs administrateur de la branche."
                ],
                command: 'ishop:import:user',
                arguments: [
                  { parameter: '--branch', key: 'branch_v2' },
                  { parameter: '--batched' },
                  { parameter: '--admin' }
                ]
              }, {
                checkboxLabel: "Utilisateurs client",
                description: [
                  "Importe les utilisateurs client de la branche."
                ],
                command: 'ishop:import:user',
                arguments: [
                  { parameter: '--branch', key: 'branch_v2' },
                  { parameter: '--batched' }
                ]
              }, {
                checkboxLabel: "Ventes",
                description: [
                  "Importe les ventes de la branche."
                ],
                command: 'ishop:import:sale',
                arguments: [
                  { parameter: '--branch', key: 'branch_v2' },
                  { parameter: '--batched' }
                ]
              }, {
                checkboxLabel: "Comptes/Profiles de fidélité",
                description: [
                  "Importe les profiles de fidélité"
                ],
                command: 'ishop:import:profile',
                arguments: [
                  { parameter: '--branch', key: 'branch_v2' },
                  { parameter: '--batched' }
                ]
              }, {
                checkboxLabel: "Transaction de fidélité",
                description: [
                  "Importe les transactions de fidélité"
                ],
                command: 'ishop:import:loyal-transaction',
                arguments: [
                  { parameter: '--branch', key: 'branch_v2' },
                  { parameter: '--batched' }
                ]
              }, {
                checkboxLabel: "Comptes/Profiles de fidélité (UPDATE)",
                description: [
                  "Synchronise les points et la balance des comptes de fidélité existants"
                ],
                command: 'ishop:import:profile-update',
                arguments: [
                  { parameter: '--branch', key: 'branch_v2' }
                ]
              }
            ]
          },
          {
            short_description: 'Synchroniser une compagnie avec la V2',
            chain: [
              {
                checkboxLabel: "Configuration et inventaire",
                description: [
                  "Importe les configurations et l'inventaire de chacune de la compagnie."
                ],
                command: 'ishop:import:company',
                arguments: [
                  { parameter: '--company', key: 'company_v3_with_old_id' }
                ]
              }, {
                checkboxLabel: "Utilisateurs Admin",
                description: [
                  "Importe les utilisateurs administrateur de la compagnie."
                ],
                command: 'ishop:import:user',
                arguments: [
                  { parameter: '--company', key: 'company_v3_with_old_id' },
                  { parameter: '--batched' },
                  { parameter: '--admin' }
                ]
              }, {
                checkboxLabel: "Utilisateurs client",
                description: [
                  "Importe les utilisateurs client de la compagnie.",
                  "À NOTER: Pour une question de vitesse, les utilisateurs ne sont PAS mise-à-jour ici, seules les utilisateurs manquants sont importés"
                ],
                command: 'ishop:import:user',
                arguments: [
                  { parameter: '--company', key: 'company_v3_with_old_id' },
                  { parameter: '--batched' }
                ]
              }, {
                checkboxLabel: "Ventes",
                description: [
                  "Importe les ventes de la compagnie."
                ],
                command: 'ishop:import:sale',
                arguments: [
                  { parameter: '--company', key: 'company_v3_with_old_id' },
                  { parameter: '--batched' }
                ]
              }, {
                checkboxLabel: "Images",
                description: [
                  "Importe les images de la compagnie."
                ],
                command: 'upload:company:assets',
                arguments: [
                  { parameter: '--company', key: 'company_v3_with_old_id' },
                ]
              }
            ]
          },
          {
            short_description: 'Troubleshoot',
            chain: [
              {
                checkboxLabel: "Check totals",
                description: [
                  "Compare le nombre d'importation de la V2 et de la V3 pour une branche."
                ],
                command: 'ishop:import:check',
                arguments: [
                  { parameter: '--branch', key: 'branch_v2' }
                ]
              }
            ]
          }
        ],
        selects: {
          branch_v2: { type: 'select', api: '/api/entity/branch_v2/select' },
          company_v3_with_old_id: { type: 'select', api: '/api/entity/company/select?oldId=notNull&add=oldId' }
        },
        builder: {
          commandIndex: null,
          checkedLinks: [],
          parameters: {},
          running: false,
          canceled: false,
        },
        logs: null,
        selectionReady: false,
        lazySelection: {}
      }
    },

    computed: {
      selected() {
        return this.builder.commandIndex !== null ? this.library[this.builder.commandIndex] : null
      },
      checkboxes() {
        if (!this.selected) {
          return [];
        }
        return this.selected.chain.map(c => c.checkboxLabel)
      },
      descriptions() {
        if (!this.selected) {
          return null
        }
        return this.selected.chain
          .map(c => c.description)
          .filter((_, i) => this.builder.checkedLinks.includes(i))
          .flat()
      },
      argumentsOfSelected() {
        if (!this.selected) {
          return []
        }
        /* gather all arguments of a command, from all chains */
        let args = {};
        for (let link of this.selected.chain) {
          for (let arg of link.arguments) {
            args[arg.key] = arg
          }
        }
        return Object.values(args);
      }
    },

    watch: {
      async 'builder.commandIndex'() {
        this.builder.checkedLinks = [];
        this.builder.parameters = {};
        this.selectionReady = false;

        /* Lazy load selection of arguments */
        for (let arg of this.argumentsOfSelected) {
          let key = arg.key;
          if (key && !this.lazySelection[key]) {
            let e = this.selects[key];
            if (e.api) {
              this.$store.commit('showSpinner', true);
              let response = await Core.noThrowRequest("GET", e.api);
              this.$store.commit('showSpinner', false);
              if (response) {
                this.lazySelection[key] = response;
              } else {
                toast(`Erreur de serveur ou de configuration key: '${key}' api: '${e.api}'`, 'error')
              }
            }
          }
        }

        this.selectionReady = true;
      }
    },

    methods: {
      async run() {
        if (!this.selected) {
          toast('NO SELECTION', 'error');
          return;
        }
        if (!this.builder.checkedLinks.length) {
          toast('NO ACTION(S) SELECTED', 'error');
          return;
        }

        this.builder.running = true;
        this.logs = null;
        let response = {};
        let wasTotalSuccess = true;
        let checkedLinks = this.selected.chain
          .filter((_, i) => this.builder.checkedLinks.includes(i));

        for (let link of checkedLinks) {
          let payload = {
            command: link.command
          };
          let errors = [];
          for (let arg of link.arguments) {
            let key = arg.parameter;
            let value = arg.key ? this.builder.parameters[arg.key] : 1;
            if (!value) {
              errors.push(`REQUIRED PARAMETER ${key}`);
            }
            payload[key] = value;
          }
          if (errors.length) {
            wasTotalSuccess = false;
            toast(errors, 'error');
            break;
          }
          do {
            if (this.builder.cancel) {
              toast('CANCELLED', 'success');
              break;
            }
            try {
              response = await Core.request('POST', '/api/command_line_runner', { payload });
            } catch (e) {
              wasTotalSuccess = false;
              toast(`UNEXPECTED ERROR WHILE RUNNNING '${link.command}'`, 'error');
              break;
            }
            if (response && response.output) {
              if (this.logs === null) {
                this.logs = []
              }
              this.logs.push(
                ...response.output.map(txt => ({ txt: txt, time: moment().format('HH:mm:ss') }))
              );
              if (response.code !== 0) {
                toast(`SERVER ERROR: command returned code '${response.code}'`, 'error');
                wasTotalSuccess = false;
                break;
              }
            } else {
              toast("SERVER ERROR: no response", 'error');
              wasTotalSuccess = false;
              break;
            }
          } while (response.hasMore);
        }

        if (wasTotalSuccess) {
          toast('SUCCESS!!', 'success');
        }
        this.builder.running = false;
        this.builder.cancel = false;
      },
      cancel() {
        this.builder.cancel = true;
        toast('CANCEL ON NEXT ITERATION', 'success')
      }
    }
  }
</script>

<style lang="scss" scoped>
  .logs li {
    font-family: "Lucida Console", Monaco, monospace
  }

  .m-b-5 {
    margin-bottom: 5px;
  }
</style>